import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {  get, handleResponse, swal500 } from '../../utils/network';
import UserComponent from './UserComponent';
import { buildUrlQueryString } from '../../utils/utils';

const UserContainer = ({ entityProps, messages, columns, mock, prefetchAllPages = false, searchEnabled = false, filterEnabled = false, searchFilter, filter, enableDuplicate = false, allowCreateNew = true, enableActions = true }) => {
  const history = useHistory();
  const location = useLocation();

  const { entityName, endpoint, path } = entityProps;
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchWord, setSearchWord] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({
    page: 0,
    showSessionLogs: false
  });
  const [ searchResults, setSearchResults ] = useState([]);

  const getData = () => {
    setLoading(true)
    const url = buildUrlQueryString(endpoint, {})

    get(url)
      .then(res => handleResponse(res, { history }))
      .then(parsed => {
        console.log(parsed)
        setData(parsed.message.data);
        setSearchResults(parsed.message.data);
        setFilteredData(parsed.message.data.slice(0, 10));
        setCount(parsed.message.count);
      })
      .catch(err => swal500(err))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [location.state, messages, mock, prefetchAllPages, searchEnabled, filterEnabled]);

  const handleChangePage = (event, newPage) => {
    const newFilters = { ...filters, page: newPage };
    setFilters(newFilters);
    setFilteredData(searchResults.slice(newPage * 10, newPage * 10 + 10));
    window.scrollTo(0, 0);
  };

  const handleSearchChange = (event) => {
    setPage(0)
    setFilters({ ...filters, page: 0 })
    setSearchWord(event.target.value)
    setSearchResults(data.filter(row => searchFilter(row, event.target.value)))
    setFilteredData(data.filter(row => searchFilter(row, event.target.value)).slice(0, 10))
    setCount(data.filter(row => searchFilter(row, event.target.value)).length)
  }

  const handleOpenForm = id => history.push(`${path}/${id || 'new'}`);

  return (
    <UserComponent
      page={filters.page}
      loading={loading}
      data={filteredData}
      dataCount={count}
      path={path}
      title={messages.title}
      columns={columns}
      handleChangePage={handleChangePage}
      filters={filters}
      setFilters={setFilters}
      enableSearch={searchEnabled}
      searchFilter={searchFilter}
      searchWord={searchWord}
      handleSearchChange={handleSearchChange}
      enableActions={true}
      handleOpenForm={handleOpenForm}
    />
  );
};

export default UserContainer;